export const light = {
  "alternate": {
    "main": "rgb(247, 249, 250)",
    "dark": "#0076BD",
  },
  "cardShadow": "rgba(23, 70, 161, .11)",
  "boxShadowStart": "rgba(22,28,45,.1)",
  "boxShadowEnd": "rgba(22,28,45,.05)",
  "type": "light",
  "primary": {
    "main": "#0076BD",
    "light": "rgb(71, 145, 219)",
    "dark": "rgb(17, 82, 147)",
    "selectedCard": "#0076BD",
    "contrastText": "#fff"
  },
  "secondary": {
    "light": "#ffb74d",
    "main": "#f9b934",
    "dark": "#f57c00",
    "contrastText": "rgba(0, 0, 0, 0.87)"
  },
  "text": {
    "primary": "#2d3748",
    "secondary": "#718096",
  },
  "required": {
    "primary": "#b53f57",
    "secondary": "#b53f57",
  },
  "icon": {
    "primary": "#0076BD",
    "gray": "#58595B",
    "current": "#339900",
    "pending": "purple",
    "missing": "#ffcc00",
    "expired": "#cc3300",
    "expiring": "#7EA9EA",

  },
  "divider": "rgba(0, 0, 0, 0.12)",
  "background": {
    "header": "#0076BD",
    "paper": "#fff",
    "default": "#fff",
    "level2": "#f5f5f5",
    "level1": "#fff",
    "footer": "#0076BD",
    "dashButton": "#EBF2FA",
    "subHeader": "#EBF2FA",
    "topbar": "#fff"
  },
};

export const dark = {
  "alternate": {
    "main": "#2D3748",
    "dark": "#24242b",
  },
  "cardShadow": "rgba(0, 0, 0, .11)",
  "boxShadowStart": "rgba(255,255,255,.1)",
  "boxShadowEnd": "rgba(255,255,255,.05)",
  "common": {
    "black": "#000",
    "white": "#fff"
  },
  "type": "dark",
  "primary": {
    "main": "#90caf9",
    "light": "rgb(166, 212, 250)",
    "dark": "rgb(100, 141, 174)",
    "selectedCard": "rgb(100, 141, 174)",
    "contrastText": "rgba(0, 0, 0, 0.87)"
  },
  "secondary": {
    "light": "#ffb74d",
    "main": "#f9b934",
    "dark": "#f57c00",
    "contrastText": "rgba(0, 0, 0, 0.87)"
  },
  "text": {
    "primary": "#EEEEEF",
    "secondary": "#f0f2f5",
  },
  "required": {
    "primary": "#b53f57",
    "secondary": "#b53f57",
  },
  "icon": {
    "primary": "#718096",
    "current": "#ffcc00",
    "expired": "#ff9966",
    "missing": "#ffcc00",
    "pending": "pink",
    "expiring": "#7EA9EA",
  },
  "divider": "rgba(255, 255, 255, 0.12)",
  "background": {
    "paper": "#1A202C",
    "default": "#121212",
    "level2": "#333",
    "level1": "#2D3748",
    "footer": "#18181f",
    "dashButton": "#606060",
    "topbar": "#18181f",
  },
};